"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedBlockViewStore = exports.LocalStorageKey = exports.SortItemTelemetryLabelMap = exports.sortMenuAssets = void 0;
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var DashboardTypes_1 = require("Dashboard/DashboardTypes");
var lodash_1 = require("lodash");
var SavedBlockFilterViewStore_1 = require("./SavedBlockFilterViewStore");
var SortBySelector_1 = require("Dashboard/SortBySelector/SortBySelector");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var DashboardTypes_2 = require("@CommonFrontendBackend/Dashboard/DashboardTypes");
exports.sortMenuAssets = [
    {
        type: SortBySelector_1.MenuItem.Created,
        text: "Date Created",
        icon: react_1.default.createElement(icons_1.Clock, null),
        sortBy: DashboardTypes_1.SortBy.CreatedAt,
    },
    {
        type: SortBySelector_1.MenuItem.Name,
        text: "Alphabetical",
        icon: react_1.default.createElement(icons_1.Fonts, null),
        sortBy: DashboardTypes_1.SortBy.Name,
    },
];
exports.SortItemTelemetryLabelMap = (_a = {},
    _a[SortBySelector_1.MenuItem.Created] = "date created",
    _a[SortBySelector_1.MenuItem.Name] = "alphabetical",
    _a);
var LocalStorageKey;
(function (LocalStorageKey) {
    LocalStorageKey["SortBy"] = "blockLibrarySortBy";
    LocalStorageKey["SortDirection"] = "blockLibrarySortDirection";
})(LocalStorageKey || (exports.LocalStorageKey = LocalStorageKey = {}));
var SavedBlockViewStore = (function () {
    function SavedBlockViewStore(savedBlockDataStore, savedBlockService, localStorageOptions, blockTypesToExclude) {
        if (localStorageOptions === void 0) { localStorageOptions = { enabled: true, localStorageKeyPrefix: "" }; }
        if (blockTypesToExclude === void 0) { blockTypesToExclude = []; }
        var _this = this;
        this.savedBlockDataStore = savedBlockDataStore;
        this.savedBlockService = savedBlockService;
        this.localStorageOptions = localStorageOptions;
        this.blockTypesToExclude = blockTypesToExclude;
        this._savedBlocks = [];
        this._selectedBlockTypeFilterList = [];
        this._editingLockedToAdminFilter = SavedBlockFilterViewStore_1.EditingLockedToAdminFilter.ShowAllBlocks;
        this.setCurrentFolder = function (value) {
            _this._currentFolder = value;
        };
        this.setSortOptions = function (sortBy, sortDirection) {
            if (sortBy === _this._sortBy && sortDirection === _this._sortDirection) {
                return;
            }
            if (sortBy !== _this._sortBy) {
                if (_this.localStorageOptions.enabled) {
                    localStorage.setItem(LocalStorageKey.SortBy, sortBy);
                }
                _this._sortBy = sortBy;
            }
            if (sortDirection !== _this._sortDirection) {
                if (_this.localStorageOptions.enabled) {
                    localStorage.setItem(LocalStorageKey.SortDirection, sortDirection);
                }
                _this._sortDirection = sortDirection;
            }
            _this.refreshSavedBlockList();
        };
        this.setSearchTerm = function (searchTerm) {
            if (_this._searchTerm === searchTerm) {
                return;
            }
            _this._searchTerm = searchTerm;
            _this.refreshSavedBlockList();
        };
        this.clearAllFilters = function () {
            if (_this.selectedBlockTypeFilterList.length > 0) {
                _this.setBlockTypeFilterList([]);
            }
            _this.setEditingLockedToAdminFilter(SavedBlockFilterViewStore_1.EditingLockedToAdminFilter.ShowAllBlocks);
        };
        this.removeFilterEntry = function (type) {
            _this._selectedBlockTypeFilterList = _this._selectedBlockTypeFilterList.filter(function (e) { return e !== type; });
            _this.refreshSavedBlockList();
        };
        this.addFilterEntry = function (type) {
            _this._selectedBlockTypeFilterList.push(type);
            _this.refreshSavedBlockList();
        };
        this.restoreFilterAndSearchStates = function (savedStates) {
            if (savedStates.searchTerm) {
                _this.setSearchTerm(savedStates.searchTerm);
            }
            if (savedStates.filterList && (0, lodash_1.isArray)(savedStates.filterList) && savedStates.filterList.length > 0) {
                _this.setBlockTypeFilterList(savedStates.filterList);
            }
        };
        this.deleteSavedBlock = function (id) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.savedBlockService.delete(id)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        this.setLockEditingSettingForSavedBlock = function (id, newState) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.savedBlockService.setLockEditingSetting(id, newState)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        this.setBlockTypeFilterList = function (filterList) {
            _this._selectedBlockTypeFilterList = filterList;
            _this.refreshSavedBlockList();
        };
        this.setEditingLockedToAdminFilter = function (selected) {
            _this._editingLockedToAdminFilter = selected;
            _this.refreshSavedBlockList();
        };
        this.sortSavedBlocks = function (savedBlocks) {
            switch (_this.sortBy) {
                case DashboardTypes_1.SortBy.CreatedAt:
                    if (_this.sortDirection === DashboardTypes_1.SortDirection.Ascending) {
                        return __spreadArray([], __read(savedBlocks), false).sort(function (a, b) {
                            return a.createdAt.localeCompare(b.createdAt);
                        });
                    }
                    else {
                        return __spreadArray([], __read(savedBlocks), false).sort(function (a, b) {
                            return b.createdAt.localeCompare(a.createdAt);
                        });
                    }
                case DashboardTypes_1.SortBy.Name:
                    if (_this.sortDirection === DashboardTypes_1.SortDirection.Ascending) {
                        return __spreadArray([], __read(savedBlocks), false).sort(function (a, b) {
                            return a.savedBlockName.localeCompare(b.savedBlockName);
                        });
                    }
                    else {
                        return __spreadArray([], __read(savedBlocks), false).sort(function (a, b) {
                            return b.savedBlockName.localeCompare(a.savedBlockName);
                        });
                    }
            }
        };
        this.getBlocksByFolderId = function (folderId) {
            if (folderId === DashboardTypes_2.SavedBlockCollection.All || !folderId) {
                return _this.savedBlockDataStore.savedBlocks.filter(function (block) { return !block.parentFolder; });
            }
            return _this.savedBlockDataStore.savedBlocks.filter(function (block) { return block.parentFolder === folderId; });
        };
        this.filterSavedBlocksByFolderId = function (folderId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([folderId_1], __read(args_1), false), Promise, function (folderId, shouldFetch) {
                var savedBlocks;
                var _a;
                if (shouldFetch === void 0) { shouldFetch = true; }
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (this._currentFolder === folderId) {
                                return [2];
                            }
                            this.setCurrentFolder(folderId);
                            if (!shouldFetch) return [3, 2];
                            return [4, this.savedBlockDataStore.fetchSavedBlocksByFolderId(folderId)];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2:
                            savedBlocks = this.getBlocksByFolderId(folderId);
                            if (this.sortBy && this.sortDirection) {
                                savedBlocks = (_a = this.sortSavedBlocks(savedBlocks)) !== null && _a !== void 0 ? _a : [];
                            }
                            this._savedBlocks = savedBlocks;
                            return [2];
                    }
                });
            });
        };
        this.moveBlockToFolder = function (blockId, folderId) { return __awaiter(_this, void 0, Promise, function () {
            var savedBlock;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.savedBlockDataStore.fetchSavedBlocksByFolderId(folderId)];
                    case 1:
                        _a.sent();
                        savedBlock = this.savedBlockDataStore.savedBlocks.find(function (block) { return block.id === blockId; });
                        if (folderId === DashboardTypes_2.SavedBlockCollection.All) {
                            folderId = null;
                        }
                        if (savedBlock) {
                            savedBlock.parentFolder = folderId;
                        }
                        return [2];
                }
            });
        }); };
        this.refreshSavedBlockList = function () {
            var _a;
            var savedBlocks = [];
            var blocksInFolder = _this.getBlocksByFolderId(_this._currentFolder);
            if (_this.searchTerm) {
                savedBlocks = blocksInFolder.filter(function (block) { var _a, _b; return (_a = block.savedBlockName) === null || _a === void 0 ? void 0 : _a.toUpperCase().includes((_b = _this.searchTerm) === null || _b === void 0 ? void 0 : _b.toUpperCase()); });
            }
            else {
                savedBlocks = blocksInFolder;
            }
            if (_this.selectedBlockTypeFilterList.length > 0) {
                savedBlocks = savedBlocks.filter(function (block) { return _this.selectedBlockTypeFilterList.includes(block.type); });
            }
            if (_this._editingLockedToAdminFilter === SavedBlockFilterViewStore_1.EditingLockedToAdminFilter.EditableByAdminsOnly) {
                savedBlocks = savedBlocks.filter(function (block) { return block.$editingLockedToAdmins; });
            }
            else if (_this._editingLockedToAdminFilter === SavedBlockFilterViewStore_1.EditingLockedToAdminFilter.EditableByEveryone) {
                savedBlocks = savedBlocks.filter(function (block) { return !block.$editingLockedToAdmins; });
            }
            if (_this.sortBy && _this.sortDirection) {
                savedBlocks = (_a = _this.sortSavedBlocks(savedBlocks)) !== null && _a !== void 0 ? _a : [];
            }
            _this._savedBlocks = savedBlocks;
        };
        this.getSelectedSortMenuItem = function () {
            switch (_this.sortBy) {
                case DashboardTypes_1.SortBy.CreatedAt:
                    return SortBySelector_1.MenuItem.Created;
                case DashboardTypes_1.SortBy.Name:
                    return SortBySelector_1.MenuItem.Name;
            }
        };
        this.onSelectSortMenuItemHandle = function (sortBy, sortDirection) {
            _this.setSortOptions(sortBy, sortDirection);
        };
        if (this.localStorageOptions.enabled) {
            this._sortBy = this.localStorageSortBy || exports.sortMenuAssets[0].sortBy;
            this._sortDirection = this.localStorageSortDirection || DashboardTypes_1.SortDirection.Descending;
        }
        else {
            this._sortBy = exports.sortMenuAssets[0].sortBy;
            this._sortDirection = DashboardTypes_1.SortDirection.Descending;
        }
        this.refreshSavedBlockList();
        (0, mobx_1.reaction)(function () {
            return savedBlockDataStore.savedBlocks.map(function (savedBlock) { return ({
                savedBlockName: savedBlock.savedBlockName,
                lastEditedAt: savedBlock.lastEditedAt || null,
                lastUsedAt: savedBlock.lastUsedAt || null,
                parentFolder: savedBlock.parentFolder || null,
                $editingLockedToAdmins: !!savedBlock.$editingLockedToAdmins,
            }); });
        }, function (blocks) {
            _this.refreshSavedBlockList();
        }, { fireImmediately: true });
    }
    Object.defineProperty(SavedBlockViewStore.prototype, "currentFolder", {
        get: function () {
            return this._currentFolder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SavedBlockViewStore.prototype, "isLoading", {
        get: function () {
            return this.savedBlockDataStore.isLoading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SavedBlockViewStore.prototype, "sortBy", {
        get: function () {
            return this._sortBy;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SavedBlockViewStore.prototype, "sortDirection", {
        get: function () {
            return this._sortDirection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SavedBlockViewStore.prototype, "searchTerm", {
        get: function () {
            return this._searchTerm;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SavedBlockViewStore.prototype, "selectedBlockTypeFilterList", {
        get: function () {
            return this._selectedBlockTypeFilterList;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SavedBlockViewStore.prototype, "savedBlocks", {
        get: function () {
            var _this = this;
            return this._savedBlocks.filter(function (block) { return !_this.blockTypesToExclude.includes(block.type); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SavedBlockViewStore.prototype, "currentSearchAndFilterStates", {
        get: function () {
            return {
                searchTerm: this._searchTerm,
                filterList: this._selectedBlockTypeFilterList,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SavedBlockViewStore.prototype, "editingLockedToAdminFilter", {
        get: function () {
            return this._editingLockedToAdminFilter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SavedBlockViewStore.prototype, "localStorageSortBy", {
        get: function () {
            return localStorage.getItem(this.localStorageSortByKey);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SavedBlockViewStore.prototype, "localStorageSortDirection", {
        get: function () {
            return localStorage.getItem(this.localStorageSortDirectionKey);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SavedBlockViewStore.prototype, "localStorageSortByKey", {
        get: function () {
            return this.localStorageOptions.localStorageKeyPrefix + LocalStorageKey.SortBy;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SavedBlockViewStore.prototype, "localStorageSortDirectionKey", {
        get: function () {
            return this.localStorageOptions.localStorageKeyPrefix + LocalStorageKey.SortDirection;
        },
        enumerable: false,
        configurable: true
    });
    var _b, _c, _d, _e, _f;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Array)
    ], SavedBlockViewStore.prototype, "_savedBlocks", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_b = typeof DashboardTypes_1.SortBy !== "undefined" && DashboardTypes_1.SortBy) === "function" ? _b : Object)
    ], SavedBlockViewStore.prototype, "_sortBy", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_c = typeof DashboardTypes_1.SortDirection !== "undefined" && DashboardTypes_1.SortDirection) === "function" ? _c : Object)
    ], SavedBlockViewStore.prototype, "_sortDirection", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], SavedBlockViewStore.prototype, "_searchTerm", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], SavedBlockViewStore.prototype, "_hasRestored", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], SavedBlockViewStore.prototype, "_currentFolder", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Array)
    ], SavedBlockViewStore.prototype, "_selectedBlockTypeFilterList", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "_editingLockedToAdminFilter", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], SavedBlockViewStore.prototype, "currentFolder", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "setCurrentFolder", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SavedBlockViewStore.prototype, "isLoading", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_d = typeof DashboardTypes_1.SortBy !== "undefined" && DashboardTypes_1.SortBy) === "function" ? _d : Object),
        __metadata("design:paramtypes", [])
    ], SavedBlockViewStore.prototype, "sortBy", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_e = typeof DashboardTypes_1.SortDirection !== "undefined" && DashboardTypes_1.SortDirection) === "function" ? _e : Object),
        __metadata("design:paramtypes", [])
    ], SavedBlockViewStore.prototype, "sortDirection", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], SavedBlockViewStore.prototype, "searchTerm", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], SavedBlockViewStore.prototype, "selectedBlockTypeFilterList", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], SavedBlockViewStore.prototype, "savedBlocks", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], SavedBlockViewStore.prototype, "currentSearchAndFilterStates", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_f = typeof SavedBlockFilterViewStore_1.EditingLockedToAdminFilter !== "undefined" && SavedBlockFilterViewStore_1.EditingLockedToAdminFilter) === "function" ? _f : Object),
        __metadata("design:paramtypes", [])
    ], SavedBlockViewStore.prototype, "editingLockedToAdminFilter", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "setSortOptions", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "setSearchTerm", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "clearAllFilters", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "removeFilterEntry", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "addFilterEntry", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "restoreFilterAndSearchStates", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "deleteSavedBlock", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "setLockEditingSettingForSavedBlock", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "setBlockTypeFilterList", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "setEditingLockedToAdminFilter", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "getBlocksByFolderId", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "filterSavedBlocksByFolderId", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "moveBlockToFolder", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "refreshSavedBlockList", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "getSelectedSortMenuItem", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockViewStore.prototype, "onSelectSortMenuItemHandle", void 0);
    return SavedBlockViewStore;
}());
exports.SavedBlockViewStore = SavedBlockViewStore;
